// @ import redux slice
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  venderData: {},
  stripeOnboardingRequired: false,
  stripeStatus: null,
};

export const venderSlice = createSlice({
  name: 'vender',
  initialState,
  reducers: {
    storeVenderData(state, action) {
      state.venderData = action.payload;
    },
    setStripeOnboardingRequired(state, action) {
      state.stripeOnboardingRequired = action.payload;
    },
    setStripeStatus(state, action) {
      state.stripeStatus = action.payload;
    },
  },
});

export const { storeVenderData, setStripeOnboardingRequired, setStripeStatus } = venderSlice.actions;

export default venderSlice.reducer;
